import { render, staticRenderFns } from "./GooglePlaystore.vue?vue&type=template&id=44479362&scoped=true"
import script from "./GooglePlaystore.vue?vue&type=script&lang=js"
export * from "./GooglePlaystore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44479362",
  null
  
)

export default component.exports